define('environments/production',{
  apiHost: 'https://landings-backend.mdirector.com',
  authHost: 'https://signup-backend.mdirector.com/auth/accessLandings',
  loginUrl: 'https://signup-backend.mdirector.com/auth/landings',
  defaultDomain: 'https://landings.mdirector.com',
  signupUrl: 'https://signup.mdirector.com',
  signupBackendUrl: 'https://signup-backend.mdirector.com',
  logoutUrl: 'https://signup-backend.mdirector.com/auth/logoutLandings',
  i18nCookieDomain: '.mdirector.com',
  cdnDomain: '//mdpages.mdirector.com',
  antispamWord: 'real_email-real_email',
  assetsHost: 'https://static.mdirector.com/assets/',
  validationServerHostSuffix: '/amp-form-validation',
  gtmUrl: 'https://www.googletagmanager.com/amp.json',
  themeAssetsUrl: 'https://static.mdirector.com/assets/themes/',
  paymentsUrl: 'https://payments.mdirector.com',
  maxImageSizeToUpload: 5242880, // 5MB

  // GruID (strings)
  groupsAllowedToAMP: [
    '30311',
    '928',
    '22069',
    '42435',
    '44125',
    '49682',
    '50023',
    '52712',
    '54043',
    '58251',
    '69293',
    '74940',
    '75859',
    '75873',
    '76415',
    '77362',
    '66848',
    '63454',
    '2',
    '2283',
    '37732',
    '3549',
    '74382',
    '79113',
    '52464',
    '35971',
    '35563',
    '63934',
    '1516',
    '61021',
    '49571',
    '92264',
    '89745',
    '47073',
    '95188',
    '95227',
    '14653',
    '4635',
  ],
});

